var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block-footer"},[_c('div',{staticClass:"locale-select"},[_c('icon',{attrs:{"name":"globe"}}),_c('dropdown-select',{staticClass:"language-picker",class:{left: _vm.$appIsSM},attrs:{"options":_vm.localeOptions},model:{value:(_vm.localeModel),callback:function ($$v) {_vm.localeModel=$$v},expression:"localeModel"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }